import { Select, SelectItem } from '@frontapp/ui-kit';
import type { FieldProps } from '../FieldWrapper';

export type Value = string | null;

export function SelectInput({
  disabled,
  field,
  options,
}: FieldProps<Value> & {
  options: Array<{ value: string | null; label: string }>;
}) {
  const selectedOption = options.find((a) => a.value === field.value);

  return (
    <Select isDisabled={disabled} selectedValues={selectedOption?.label}>
      {options.map((option) => (
        <SelectItem
          key={option.value}
          isSelected={field.value === option.value}
          onClick={() => field.onChange(option.value)}
        >
          {option.label}
        </SelectItem>
      ))}
    </Select>
  );
}
